import requests from './request'

// 获取该用户下的公众号任务配置列表
export const loginAccount = (data) => requests.post('/cas/login', data)

export const refreshToken = (data) => requests.post('/cas/authorize', data)

export const getGeeCode = (data) => requests.post('/cas/send-check-code', data)
